import ReportTable from '../../../../../components/Grid/ReportTable';

export default function CaixaTable(props: any) {
  return <ReportTable model={props.model} columnCount={9} />;
}
